import { SteemActionType } from '@popup/steem/actions/action-type.enum';
const ConversionsReducer = (state = [], { type, payload }) => {
    switch (type) {
        case SteemActionType.FETCH_CONVERSION_REQUESTS:
            return payload;
        default:
            return state;
    }
};
export default ConversionsReducer;
